import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: "sot-userprofil",
  templateUrl: "./userprofil.component.html",
  styleUrls: ["./userprofil.component.scss"]
})
export class UserProfil implements OnInit, OnDestroy {

  public constructor() { 
    console.debug("--- sot-userprofil constructor")
  }

  public ngOnInit(): void {
    console.debug("--- sot-userprofil ngOnInit")
  }

  public ngOnDestroy(): void {
    console.debug("--- sot-userprofil ngOnDestroy")
  }
}

